import { Loader } from 'components/Loader';

import { useList } from './List.hooks';
import * as S from './List.styles';

export function List(): React.ReactElement {
  const { columns, isLoading, tableData } = useList();

  return (
    <Loader isLoading={isLoading}>
      {tableData ? (
        <S.StyledTable motive="senary" columns={columns} data={tableData} />
      ) : undefined}
    </Loader>
  );
}
